import { Link } from "react-router-dom";
import styles from "./style/Story.module.css";
import Menu from "./menu.png";
import Music from "./image15.png";
import Story1 from "./story1.jpg";
import Story2 from "./story2.jpg";
import Story3 from "./story3.jpg";
import Content from "./Storycontent.js";

function ChangeContent1() {
  let menu = document.getElementById("Menu");
  menu.style.height = "100vh";
}

function ChangeContent2() {
  let menu = document.getElementById("Menu");
  menu.style.height = "0";
}

function Introduction() {
  return (
    <div className={styles.main}>
      <div className={styles.menu} id="Menu">
        <div className={styles.menutitle}>
          <Link to="/" className={styles.menutitletext}>
            <div>Rhythm with Game</div>
          </Link>
          <img
            src={Menu}
            className={styles.menuimg}
            id="icon"
            onClick={ChangeContent2}
          />
        </div>
        <div className={styles.menutext}>A playable website for music</div>
        <Link to="/introduction" className={styles.link}>
          <div>Introduction</div>
        </Link>
        <Link to="/games" className={styles.link}>
          <div>Games</div>
        </Link>
        <div className={styles.speciallink} onClick={ChangeContent2}>
          Creator's Story
        </div>
        <Link to="/music" className={styles.link}>
          <div>
            <img className={styles.listen} src={Music} /> Enjoy the Music
          </div>
        </Link>
      </div>
      <div className={styles.original} id="Original">
        <div className={styles.title}>
          <div className={styles.titletext}>Creator's Story</div>
          <img src={Menu} className={styles.img} onClick={ChangeContent1} />
        </div>
        <div className={styles.notmobile}>
          <Content />
        </div>
        <div className={styles.mobile}>
          <div className={styles.storyCountainer}>
            <div className={styles.storytext}>
              <div>
                The first time I encountered rhythm games was in high school.
                One day, while hanging out with friends, one of them showed me a
                bunch of rhythm games on his iPad. Watching his fingers dance
                across the screen, hitting perfect notes one after another, I
                couldn't help but be drawn in by the wonderful music and visual
                effects. That moment marked the beginning of my enduring love
                affair with rhythm games.
              </div>
              <img class={styles.storyimg} src={Story1} />
            </div>
            <div class={styles.storytext}>
              <img class={styles.storyimg} src={Story2} />
              <div>
                When I first entered university, rhythm games became almost like
                a lifeline for me. I found immense joy in heading to the arcade
                to play Maimai every Friday, and during breaks between classes,
                I would rotate through various games, striving to achieve high
                scores. Rhythm games provided me with a profound sense of
                accomplishment, reinforcing the belief that hard work always
                pays off.
              </div>
            </div>
            <div class={styles.storytext}>
              <div>
                At the same time, the unique music styles and mesmerizing art
                aesthetics of rhythm games captivated me deeply, influencing my
                sense of aesthetics. Although music is the core of rhythm games,
                and the music itself is often outstanding, each game also has
                its own story and worldview, which further enticed me to
                explore.
              </div>
              <img class={styles.storyimg} src={Story3} />
            </div>
            <div class={styles.storytext}>
              As a member of a niche gaming community, I'm eager to share the
              unique charm of rhythm games with more people. Hence, the idea of
              creating this website was born. While it may not be the most
              comprehensive resource for rhythm games, I hope it will spark
              interest in others, and for me, that's enough.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Introduction;
